export const selectPanelIsVisible = (state) => state.ui.panelIsVisible
export const selectListIsVisible = (state) => state.ui.listIsVisible
export const selectMobileCardIsVisible = (state) => state.ui.mobileCardIsVisilbe
